<div class="d-flex gap-3 flex-column">
    <div class="d-flex flex-column w-100 align-items-start gap-4"
        [ngClass]="{'flex-md-row align-items-md-center': isResponsive}">
        <label class="small text-nowrap" [ngStyle]="{'width': width}" *ngIf="label">
            {{label}}
            <span *ngIf="control.hasError('required')" style="color: red;">*</span>
        </label>
        <input [type]="type" [formControl]="control" class="custom-input custom-input-one" [placeholder]="placeholder"
            [ngClass]="{'is-invalid': isInvalid()}" *ngIf="!formatAsMoney" />
        <input [type]="type" [formControl]="control" class="custom-input custom-input-one" [placeholder]="placeholder"
            [ngClass]="{'is-invalid': isInvalid()}" *ngIf="formatAsMoney" appThousandSeparator />
    </div>
    <div class="d-flex flex-row w-100 align-items-center justify-content-end">
        <span class="error-label" *ngIf="isInvalid()">
            {{errorMessage}}
        </span>
    </div>
</div>